export default __webpack_public_path__ + "static/media/Group 2661.f1cffe40.png";